import 'promis';
import FontFaceObserver from 'fontfaceobserver';

const htmlEl = document.documentElement;
const TIMEOUT = 5000;

function addFont({ family, suffix }) {
  const name = family.toLowerCase().replace(/ /g, '-');
  const className = `loaded-${name}-${suffix}`;
  htmlEl.classList.add(className);
}

function handleError(err) {
  console.error(err);
}

function loadFont(fonts) {
  fonts.forEach((font) => {
    const { family, weight } = font;
    const fontObserver = new FontFaceObserver(family, { weight });
    fontObserver
      .load(null, TIMEOUT)
      .then(() => addFont(font))
      .catch(handleError);
  });
}

export default loadFont;
